import {
  PORTABLE_DESIGNER_NODE_TYPE,
  PORTABLE_DESIGNER_NODE_VERSION,
  type DesignerNodeData,
  type PortableDesignerNodeInContext,
  type SlotId,
} from "../schemas/index.ts";
import type { GetPortableDesignerNode } from "./getPortableDesignerNode.ts";
import type { GetPortableNodeLinkages } from "./getPortableNodeLinkages.ts";

interface Options {
  getPortableDesignerNode: GetPortableDesignerNode;
  getPortableNodeLinkages: GetPortableNodeLinkages;
  origin: string;
}

interface Context {
  hostId: string;
  slotId: SlotId;
  action: PortableDesignerNodeInContext["source"]["action"];
}

export const getPortableDesignerNodeInContextCreate =
  ({ getPortableDesignerNode, getPortableNodeLinkages, origin }: Options) =>
  (node: DesignerNodeData, { hostId, slotId, action }: Context): PortableDesignerNodeInContext => {
    const portableNode = getPortableDesignerNode(node); // note this populates triggers property
    const linkages = getPortableNodeLinkages(portableNode);
    return {
      type: PORTABLE_DESIGNER_NODE_TYPE, // might be mime type if we did clipboard item instead
      version: PORTABLE_DESIGNER_NODE_VERSION,
      source: {
        origin,
        hostId,
        slotId,
        action,
        appVersion: APP_VERSION,
      },
      node: portableNode,
      linkages,
    };
  };

export type GetPortableDesignerNodeInContext = ReturnType<typeof getPortableDesignerNodeInContextCreate>;
